import { gql } from '@apollo/client'

export const GET_TRENDINGS_BY_CATEGORY_QUERY = gql`
  query getTrendingsByCategory {
    getTrendingHome {
      status
      relatedTerritory {
        territoryId
        name
      }
      data {
        id
        name
        query
        filtersObject
        totalPosts
        relevance
        status: trendingType
      }
    }
  }
`
